import CartLoader from './cart-loader';

export default class Product {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {
        hasSubscriptions: !!document.querySelector('.js-enable-subscriptions'),
        initialLoad: true,
        rechargeProducts: {}
      };

      this.setupEventListeners();
      this.reset();
      this.getRechargeDataOnLoad(50);

      this.updateColorLabel();

      setTimeout(() => {
        this.state.initialLoad = false;
      }, 4000);
    }
  }

  //===========================================================================
  // Sets/Resets the PDP
  //===========================================================================

  reset() {
    this.setState();
    this.adjustStickyFooter();
    this.initialOptionAvailabilityAdjustment();
    this.updateSubscriptionOnLoad();
    this.updateColorLabel();
  }

  //===========================================================================
  // Sets the state
  //===========================================================================

  setState() {
    this.state.$atc = $('.js-pdp .js-add-to-cart');
    this.state.$stickyFooter = $('.js-pdp-sticky-footer');
  }

  //===========================================================================
  // Gets product JSON data
  //===========================================================================

  getProductData($parent) {
    let data = $parent.find('.js-product-data')[0];
    data = data ? JSON.parse(data.innerText) : null;

    return data;
  }

  //===========================================================================
  // Adjusts the availability of the option buttons on page load.
  //===========================================================================

  initialOptionAvailabilityAdjustment() {
    const $products = $('.js-product-wrapper');
    const $pdp = $('.js-pdp');

    $products.each((i, product) => {
      const $product = $(product);
      this.adjustOptionAvailability($product);
    });

    if ($pdp.length) {
      $pdp.find('.js-product-option').first().trigger('change');
    }
  }

  //===========================================================================
  // Adjusts the availability of the option buttons.
  // Ex: If a size option doesn't exist for a certain color, disable the size.
  //===========================================================================

  adjustOptionAvailability($parent) {
    const $options = $parent.find('.js-product-option-radio:checked');
    const productData = this.getProductData($parent);

    if ($options[0] && productData && productData.variants) {
      let availableVariants = productData.variants;

      $options.each((i, option) => {
        const $option = $(option);
        const $siblings = $option.closest('.js-product-option-wrapper').find('.js-product-option-radio');
        let tempVariants = availableVariants;
        let $selectedOption = $option;

        $siblings.each((j, sibling) => {
          const $sibling = $(sibling);
          const isAvailable = availableVariants.filter((variant) => {
            return variant[$sibling.data('index')] === $sibling.val();
          }).length;

          if (isAvailable) {
            $sibling.prop('disabled', false);
          } else {
            $sibling.prop('disabled', true);
            $sibling.prop('checked', false);
          }
        });

        availableVariants = tempVariants.filter((variant) => {
          return variant[$selectedOption.data('index')] === $selectedOption.val();
        });

        if (!availableVariants.length) {
          $selectedOption = $siblings.not(':disabled').first();
          $selectedOption.prop('checked', true);

          availableVariants = tempVariants.filter((variant) => {
            return variant[$selectedOption.data('index')] === $selectedOption.val();
          });
        }
      });
    }
  }

  //===========================================================================
  // Gets the selected variant
  //===========================================================================

  getSelectedVariant($parent) {
    const $options = $parent.find('.js-product-option-radio:checked, .js-product-option-list');
    const productData = this.getProductData($parent);
    let variant;

    if (productData?.variants?.length === 1) {
      return productData.variants[0];
    } else if ($options[0] && productData?.variants) {
      productData.variants.forEach((v) => {
        let selected = true;

        $options.each((i, option) => {
          let $option = $(option);

          if (v[$option.data('index')] !== $option.val()) {
            selected = false;
          }
        });

        if (selected) {
          variant = v;
        }
      });
    }

    return variant;
  }

  //===========================================================================
  // Updates the selected variant when an option is changed.
  //===========================================================================

  updateVariant(e) {
    const $target = $(e.currentTarget);
    const $parent = $target.closest('.js-product-wrapper');
    const $select = $parent.find('.js-product-variant-select');

    this.adjustOptionAvailability($parent);

    const variant = this.getSelectedVariant($parent);

    if (variant) {
      $select.val(variant.id);
      $parent.attr('data-variant', variant.id);
      $parent.attr('data-price', (variant.price || 0) / 100);
      $parent[0].dispatchEvent(new CustomEvent('variantChange', {
        bubbles: true,
        detail: {
          variant
        }
      }));
    } else {
      this.updateBtnForVariantChange($parent, variant);
    }
  }

  //===========================================================================
  // Makes updates for a variant change
  //===========================================================================

  onVariantChange(e) {
    const $target = $(e.currentTarget);
    const variant = e.detail.variant;

    console.log('VARIANT CHANGE');
    console.log(variant);

    if (variant && variant.id) {
      this.updatePrice($target, variant);

      if ($target.hasClass('js-pdp' )) {
        this.updateUrlForVariantChange(variant.id);
        this.updateBtnForVariantChange($target, variant);
        this.updatePageForPreorder($target, variant.id);
        this.updateForVariantAvailability(variant);
        this.updateSliderImages(variant.id);
      }
    }
  }

  async updateSliderImages(variantId) {
    const carousel = document.querySelector('.product-gallery').parentElement;
    if (!carousel) return;

    if (carousel.dataset.initialVariantId == variantId) return;

    const sectionId = carousel.closest('.shopify-section').id.replace('shopify-section-', '');

    const response = await fetch(`${location.pathname}?variant=${variantId}&section_id=${sectionId}`)
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    window.Alpine?.destroyTree?.(carousel);
    const updatedCarousel = doc.querySelector('.product-gallery').parentElement;
    carousel.replaceWith(updatedCarousel);
    window.Alpine?.nextTick(() => {
      window.Alpine?.initTree?.(updatedCarousel);
    })
    document.dispatchEvent(new CustomEvent('carousel-reset'));
  }

  updateColorLabel() {

    document.querySelectorAll('.color-swatch--list-item').forEach(item => {
        item.addEventListener('mouseover', () => {
          const optionLabel = item.closest('.js-product-option-wrapper').querySelector('.current-color-label');
          const input = item.querySelector('.js-product-option');
          const labelHTML = `<span>${input.dataset.colorOptionName.trim()}:</span>${input.dataset.shadeDescription ? ' ' + input.dataset.shadeDescription : ''}`;

          optionLabel.innerHTML = labelHTML;
        });

        item.addEventListener('mouseout', () => {
          const optionLabel = item.closest('.js-product-option-wrapper').querySelector('.current-color-label');
          const input = item.closest('.js-product-option-wrapper').querySelector('.js-product-option:checked');
          const labelHTML = `<span>${input.dataset.colorOptionName.trim()}:</span>${input.dataset.shadeDescription ? ' ' + input.dataset.shadeDescription : ''}`;

          optionLabel.innerHTML = labelHTML;
        });
    });
  }

  //===========================================================================
  // Enables or disables the installments buttons
  //===========================================================================

  updateForVariantAvailability(variant) {
    const $bisNotify = $('.klaviyo-bis-trigger');

    if (variant && variant.available) {
      $bisNotify.hide();
    } else {
      $bisNotify.show();
    }
  }

  //===========================================================================
  // Changes the page based on preorder status
  //===========================================================================

  updatePageForPreorder($parent, variantId) {
    if (window._supertheme._preorders) {
      const $form = $parent.find('.js-product-form');
      const $property = $parent.find('.js-preorder-property');
      const $message = $parent.find('.js-preorder-message');
      const isPreorder = window._supertheme._preorders[variantId] && window._supertheme._preorders[variantId].status;
      const preorderMessage = window._supertheme._preorders[variantId] && window._supertheme._preorders[variantId].message;
      const propertyTemplate = `<input type='hidden' class='js-preorder-property' name='properties[Preorder]' value='true' />`;

      $property.remove();

      if (isPreorder) {
        if (preorderMessage) {
          $message.text(preorderMessage);
        } else {
          $message.text('');
        }

        $parent.addClass('preorder');
        $form.append(propertyTemplate);
      } else {
        $parent.removeClass('preorder');
      }
    }
  }

  //===========================================================================
  // Formats a price
  //===========================================================================

  formatPrice(price = 0) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency.active ?? 'USD',
      currencyDisplay: 'narrowSymbol',
      trailingZeroDisplay: 'stripIfInteger',
    })
    return formatter.format(price / 100);
  }

  //===========================================================================
  // Updates the product price
  //===========================================================================

  updatePrice($parent, variant) {
    const $priceLabel = $parent.find('.js-product-price');
    const $compareAtLabel = $parent.find('.js-product-compare-at-price');
    const subscriptionPrice = this.getSubscriptionPrice($parent, variant);
    const price = subscriptionPrice ? subscriptionPrice : variant.price;
    const compareAtPrice = subscriptionPrice ? variant.price : variant.compare_at_price;
    const subscriptionOption = $('.js-subscription-option:checked').val();
    const $subscriptionPriceOnetime = $parent.find('.js-subscription-price-onetime');

    const frequencySelector = document.querySelector('.js-subscription-frequency');
    let sellingPlanAllocation = null;

    if (frequencySelector) {
      sellingPlanAllocation = variant.selling_plan_allocations.find(sellingPlan => sellingPlan.selling_plan_id == frequencySelector.value);
    }

    if ($compareAtLabel.hasClass('js-subscription-price')) {
      if (variant.compare_at_price > variant.price) {
        $compareAtLabel.html(this.formatPrice(variant.compare_at_price));
      } else if (sellingPlanAllocation){
        $compareAtLabel.html(this.formatPrice(variant.price));
      }
    }

    if (sellingPlanAllocation) {
      if ($priceLabel.hasClass('js-subscription-price')) {
        $priceLabel.html(this.formatPrice(sellingPlanAllocation.price));
      }
    }

    $subscriptionPriceOnetime.text(this.formatPrice(variant.price));


    if (subscriptionOption == 'onetime') {
      $priceLabel.not('.js-subscription-price').text(this.formatPrice(price)).removeClass('h3');
    } else {
      $priceLabel.each((i, el) => {
        if (el.classList.contains('js-subscription-price')) {
          el.innerHTML = this.formatPrice(price);
        } else {
          el.textContent = this.formatPrice(price) + '/month for subscription';
          el.classList.add('normalcase','h3');
        }
      });
    }

    if (compareAtPrice && compareAtPrice > price) {
      $compareAtLabel.html(this.formatPrice(compareAtPrice));
      if (subscriptionOption == 'subsave') {
        $compareAtLabel.not('.js-subscription-price').removeClass('text-line-through');
      }
      $compareAtLabel.removeClass('hidden');
    } else {
      $compareAtLabel.not('.js-subscription-price').text('');
      $compareAtLabel.not('.js-subscription-price').addClass('hidden');
    }
  }

  //===========================================================================
  // Updates the PDP URL when a variant changes.
  //===========================================================================

  updateUrlForVariantChange(variantId) {
    let newUrl = window.location.origin + window.location.pathname;

    if (variantId) {
      newUrl += "?variant=" + String(variantId);
    }

    history.replaceState({}, String(variantId), newUrl);
  }

  //===========================================================================
  // Enables or disables the ATC buttons
  //===========================================================================

  updateBtnForVariantChange($parent, variant) {
    if (variant && variant.available) {
      $parent.find('.js-add-to-cart').removeClass('disabled');
      $parent.find('.js-add-to-cart-alias').removeClass('disabled');
    } else {
      $parent.find('.js-add-to-cart').addClass('disabled');
      $parent.find('.js-add-to-cart-alias').addClass('disabled');
    }
  }

  //===========================================================================
  // Shows or hides the sticky footer.
  //===========================================================================

  adjustStickyFooter() {
    if (this.state.$atc[0]) {
      const bounds = this.state.$atc[0] ? this.state.$atc[0].getBoundingClientRect() : null;
      const $body = $('body');

      if (bounds && bounds.top < 50) {
        this.state.$stickyFooter.addClass('active');
        $body.addClass('hide-widgets');
      } else {
        this.state.$stickyFooter.removeClass('active');
        $body.removeClass('hide-widgets');
      }
    }
  }

  //===========================================================================
  // Datalayer event for ATC tracking
  //===========================================================================

  addToCartTracking($parent) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'addToCart',
      'productTitle': $parent.data('title') || '',
      'productVariantId': $parent.data('variant') || '',
      'productPrice': $parent.data('price') || '',
      'productQty': 1
    });
  }

  //===========================================================================
  // A dummy ATC button that triggers a click on the real button.
  //===========================================================================

  addToCartAlias(e) {
    const $target = $(e.currentTarget);
    const $parent = $target.closest('.js-product-wrapper');
    const $atc = $parent.find('.js-add-to-cart');

    $atc.click();
  }

  //===========================================================================
  // Adds product to cart
  //===========================================================================

  addToCart(e) {
    const $target  = $(e.currentTarget);
    const $parent  = $target.closest('.js-product-wrapper');

    this.disableRechargeWidget($parent);

    const $form    = $parent.find('.js-product-form');
    const formData = this.formatFormData($form);

    e.preventDefault();

    this.addToCartTracking($parent);
    new CartLoader({ payload: formData, openDrawer: true });
  }

  //===========================================================================
  // Formats serialized cart data with correct subscription ID
  //===========================================================================

  formatFormData($form) {
    const productId = $form.data('product-id');
    const sellingPlanId = this.state.rechargeProducts[productId];
    let serialized = $form.serialize();

    if (productId && sellingPlanId && serialized.includes(`selling_plan_${ productId }`)) {
      serialized = serialized.replace(`selling_plan_${ productId }`, `selling_plan_${ sellingPlanId }`);
    }

    // console.log('SELLING PLAN');
    // console.log(this.state.rechargeProducts);
    // console.log(productId)
    // console.log(sellingPlanId);
    // console.log(serialized);

    return serialized;
  }

  //===========================================================================
  // Gets Recharge product data on load
  //===========================================================================

  getRechargeDataOnLoad(count) {
    if (this.state.hasSubscriptions && count > 0) {
      if (window.ReChargeWidget) {
        this.getRechargeData();
      } else {
        setTimeout(() => {
          this.getRechargeDataOnLoad(count - 1);
        }, 500);
      }
    }
  }

  //===========================================================================
  // Gets Recharge product data
  //===========================================================================

  getRechargeData() {
    window.ReChargeWidget.api.fetchProducts().then((data) => {
      const mergedData = data.reduce((a, b) => {return {...a, ...b} }, {});

      for (let key in mergedData) {
        const rechargeData = mergedData[key];
        const sellingPlanGroup = rechargeData.selling_plan_groups ? rechargeData.selling_plan_groups[0] : null;
        const sellingPlanGroupId = sellingPlanGroup ? sellingPlanGroup.selling_plan_group_id : null;
        mergedData[key] = sellingPlanGroupId;
      }

      this.state.rechargeProducts = mergedData;
    });
  }

  //===========================================================================
  // Updates the hidden Recharge widget on page load
  //===========================================================================

  updateSubscriptionOnLoad() {
    if (this.state.hasSubscriptions) {
      const $input = $('.js-subscription-option').first();
      $input.trigger('change');
    }
  }

  //===========================================================================
  // Disables the recharge widget so it doesn't add input fields during ATC
  //===========================================================================

  disableRechargeWidget($parent) {
    $parent.find('.rc_container').find('input, select').prop('disabled', true);
  }

  //===========================================================================
  // Updates the form for Recharge
  //===========================================================================

  updateSubscription(e) {
    const $target = $(e.currentTarget);
    const $parent = $target.closest('.js-product-wrapper');
    const $freqInput = $parent.find('.js-subscription-frequency');
    const $freqWrap = $parent.find('.js-subscription-frequency-wrapper');
    const $subProps = $parent.find('.js-subscription-property');
    const frequency = $parent.find('.js-subscription-frequency').val();
    const status  = $parent.find('.js-subscription-status:checked').val();
    const variant   = this.getSelectedVariant($parent);
    const selectedClass = 'product-template--subscription-status__selected';

    $parent.find('.product-template--subscription-status').removeClass(selectedClass).each((i, el) => {
      if (el.querySelector('.js-subscription-option:checked')) {
          el.classList.add(selectedClass);
      }
    });


    if (frequency) {
      this.disableRechargeWidget($parent);

      if (status) {
        $parent.find(`.js-subscription-status[value="${ status }"]`).prop('checked', true);
      }

      if (status === 'subsave') {
        // $freqWrap.removeClass('hidden');
        $freqInput.prop('name', 'selling_plan');
        $subProps.prop('disabled', false);
      } else if (status === 'onetime') {
        // $freqWrap.addClass('hidden');
        $freqInput.prop('name', '');
        $subProps.prop('disabled', true);
      }

      if (variant && variant.id) {
        this.updatePrice($parent, variant);
      }
    }
  }

  //===========================================================================
  // Gets the price of a selected subscription.
  //===========================================================================

  getSubscriptionPrice($parent, variant) {
    const isSub = !!$parent.find('.js-subscription-option[value="subsave"]:checked').length;

    if (isSub && variant && variant.selling_plan_allocations) {
      let chosenSub = $parent.find('.js-subscription-frequency').val();
      let sellingPlan = variant.selling_plan_allocations.filter((plan) => {
        return plan && plan.selling_plan_id == chosenSub;
      })[0];

      if (sellingPlan) {
        return sellingPlan.price;
      }
    }

    return null;
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-add-to-cart', this.addToCart.bind(this));
    $(document).on('click', '.js-add-to-cart-alias', this.addToCartAlias.bind(this));
    $(document).on('change', '.js-product-option', this.updateVariant.bind(this));
    $(document).on('change', '.js-subscription-option', this.updateSubscription.bind(this));
    $(document).on('variantChange', '.js-product-wrapper', this.onVariantChange.bind(this));
    $(document).on('historyChange', this.reset.bind(this));
    $(window).on('resize', this.adjustStickyFooter.bind(this));
    $(window).on('scroll', this.adjustStickyFooter.bind(this));
  }
}
